export enum PaymentProtectionStatusEnum {
  ACTIVE = 'true',
  DISABLED = 'false',
}
